import React from 'react';
import styled from 'styled-components';
import { FormInput, formInput } from './FormInput';
import { Validate, ValidationValueMessage } from 'react-hook-form';

interface Props extends FormInput<string>, StyledTextInputProps {
  name: string;
  fullWidth?: boolean;
  autoComplete?: string;
  disabled?: boolean;
  type?: string;
  step?: string;
  autoFocus?: boolean;
}

export interface StyledTextInputProps {
  fullWidth?: boolean;
  padding?: string;
}

export const StyledTextInput = styled.input<StyledTextInputProps>`
  padding: ${(props) => props.padding || props.theme.forms.input.padding};
  border: solid;
  border-radius: ${(props) => props.theme.forms.input.border.radius};
  border-width: ${(props) => props.theme.forms.input.border.width};
  border-color: ${(props) => props.theme.forms.input.border.color};
  font-weight: ${(props) => props.theme.typography.defaults.fontWeight};
  width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
  
  &:disabled {
    background: rgba(255, 255, 255, 0.6);
  }
`;

export const TextInput = formInput(function (props: Props) {
  const { onChange, ...otherProps } = props;



  return (
    <StyledTextInput
      {...otherProps}
      value={props.value ?? ''}
      onChange={(event) => {
        onChange?.(event, event.currentTarget.value);
      }}
    />
  );
});
